// src/components/BottomNav.js
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, Heart, User } from 'lucide-react';

const BottomNav = () => {
  const location = useLocation();
  const [pressed, setPressed] = useState(null);
  const [animatingIcon, setAnimatingIcon] = useState(null);

  const navItems = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/shop', icon: ShoppingBag, label: 'Shop' },
    { path: '/profile/wishlist', icon: Heart, label: 'Wishlist' },
    { path: '/profile', icon: User, label: 'Profile' },
  ];

  const isActive = (path) => location.pathname === path;

  const handleClick = (path) => {
    setAnimatingIcon(path);
    setTimeout(() => setAnimatingIcon(null), 650);
  };

  return (
    <div className="md:hidden fixed bottom-4 left-0 right-0 z-40 px-4 flex justify-center pointer-events-none">
      <div
        className="flex items-center justify-between gap-1 px-3 py-3 rounded-full w-full max-w-md pointer-events-auto animate-slideUp"
        style={{
          backgroundColor: '#FFFFFF',
          boxShadow: '0 10px 40px rgba(220, 130, 154, 0.25)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
        }}
      >
        {navItems.map((item, index) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          const isPressed = pressed === item.path;
          const isAnimating = animatingIcon === item.path;

          return (
            <Link
              key={item.path}
              to={item.path}
              onClick={() => handleClick(item.path)}
              onMouseDown={() => setPressed(item.path)}
              onMouseUp={() => setPressed(null)}
              onMouseLeave={() => setPressed(null)}
              onTouchStart={() => setPressed(item.path)}
              onTouchEnd={() => setPressed(null)}
              className={`relative flex items-center justify-center gap-2 rounded-full transition-all duration-300 ease-out ${
                active ? 'px-5 py-3' : 'p-3'
              } ${isPressed ? 'scale-90' : active ? 'scale-105' : 'scale-100'}`}
              style={{
                backgroundColor: active ? '#F5AEC0' : 'transparent',
                color: active ? '#FFFFFF' : '#DC829A',
                boxShadow: active ? '0 8px 25px rgba(245, 174, 192, 0.45)' : 'none',
                transitionDelay: `${index * 25}ms`,
              }}
            >
              <Icon
                size={22}
                strokeWidth={active ? 2.5 : 2}
                className={`transition-all duration-300 ${isAnimating ? 'animate-iconBounce' : ''}`}
              />
              {active && (
                <span className="text-sm font-semibold whitespace-nowrap animate-fadeIn">
                  {item.label}
                </span>
              )}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNav;